// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"ab92f682","453":"77bc5347","455":"4e71ad54"}[chunkId] + ".chunk.js";
};